export const concatArray = (
  elements: Array<string | null | undefined>,
  separator: string = ' ',
  firstChartUpper?: boolean
) => {
  const result = elements.filter(Boolean).join(separator);

  if (firstChartUpper) {
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

  return result;
};
